// List of commands that require API calls

import {
	getProjects,
	getQuote,
	getReadme,
	getWeather,
} from "@/features/commands";

export const projects = async (_args: string[]): Promise<string> => {
	const projects = await getProjects();
	return projects
		.map(
			(repo) =>
				`${repo.name} - <a class="text-light-blue dark:text-dark-blue underline" href="${repo.html_url}" target="_blank">${repo.html_url}</a>`,
		)
		.join("\n");
};

export const quote = async (_args: string[]): Promise<string> => {
	const data = await getQuote();
	return data.quote;
};

export const readme = async (_args: string[]): Promise<string> => {
	const readme = await getReadme();
	return `Opening GitHub README...\n
  ${readme}`;
};

export const weather = async (args: string[]): Promise<string> => {
	const city = args.join("+");
	if (!city) {
		return "Usage: weather [city]. Example: weather casablanca";
	}
	const weather = await getWeather(city);
	return weather;
};
